import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue2Editor from "vue2-editor";
import Multiselect from 'vue-multiselect'
// import CKEditor from "@ckeditor/ckeditor5-vue";

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import { authHeader } from './helpers/authservice/auth-header';

authHeader();

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(Vue2Editor);
Vue.component('multiselect', Multiselect)
// Vue.use(CKEditor)

Vue.component('apexchart', VueApexCharts)
Vue.component('pagination', require('laravel-vue-pagination'));

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
